<!-- Hero Section -->
<header class="bg-info text-white text-center py-5">
  <div class="container">
    <h1 class="display-4">Our Pricing Plans</h1>
    <p class="lead">Choose a plan that fits your business needs. We offer flexible pricing to suit all types of businesses.</p>
  </div>
</header>

<!-- Pricing Section -->
<section class="py-5">
  <div class="container">
    <h2 class="text-center text-primary mb-4">Affordable Pricing Plans</h2>
    <div class="row">
      <!-- Plan 1: Basic -->
      <div class="col-md-4 mb-4">
        <div class="card shadow-sm border-primary">
          <div class="card-header bg-primary text-white text-center">
            <h4>Basic Plan</h4>
            <p class="lead">$99/month</p>
          </div>
          <div class="card-body">
            <ul class="list-unstyled">
              <li><i class="bi bi-check-circle text-success"></i> 1 Site Setup</li>
              <li><i class="bi bi-check-circle text-success"></i> 24/7 Support</li>
              <li><i class="bi bi-check-circle text-success"></i> Basic Security Features</li>
              <li><i class="bi bi-x-circle text-danger"></i> No Cloud Storage</li>
              <li><i class="bi bi-x-circle text-danger"></i> Limited Bandwidth</li>
            </ul>
            <a href="contact.html" class="btn btn-primary w-100">Get Started</a>
          </div>
        </div>
      </div>
      <!-- Plan 2: Standard -->
      <div class="col-md-4 mb-4">
        <div class="card shadow-sm border-info position-relative">
          <span class="badge bg-warning text-dark position-absolute top-0 start-50 translate-middle-x mt-2">Most Popular</span>
          <div class="card-header bg-info text-white text-center">
            <h4>Standard Plan</h4>
            <p class="lead">$199/month</p>
          </div>
          <div class="card-body">
            <ul class="list-unstyled">
              <li><i class="bi bi-check-circle text-success"></i> 3 Site Setups</li>
              <li><i class="bi bi-check-circle text-success"></i> Priority Support</li>
              <li><i class="bi bi-check-circle text-success"></i> Advanced Security Features</li>
              <li><i class="bi bi-check-circle text-success"></i> 10 GB Cloud Storage</li>
              <li><i class="bi bi-x-circle text-danger"></i> Limited Bandwidth</li>
            </ul>
            <a href="contact.html" class="btn btn-info w-100">Get Started</a>
          </div>
        </div>
      </div>
      <!-- Plan 3: Premium -->
      <div class="col-md-4 mb-4">
        <div class="card shadow-sm border-success">
          <div class="card-header bg-success text-white text-center">
            <h4>Premium Plan</h4>
            <p class="lead">$399/month</p>
          </div>
          <div class="card-body">
            <ul class="list-unstyled">
              <li><i class="bi bi-check-circle text-success"></i> Unlimited Site Setups</li>
              <li><i class="bi bi-check-circle text-success"></i> Dedicated Support</li>
              <li><i class="bi bi-check-circle text-success"></i> Enhanced Security Features</li>
              <li><i class="bi bi-check-circle text-success"></i> 50 GB Cloud Storage</li>
              <li><i class="bi bi-check-circle text-success"></i> Unlimited Bandwidth</li>
            </ul>
            <a href="contact.html" class="btn btn-success w-100">Get Started</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- FAQ Section -->
<section class="py-5 bg-light">
  <div class="container">
    <h2 class="text-center text-primary mb-4">Frequently Asked Questions</h2>
    <div class="accordion" id="faqAccordion">
      <div class="accordion-item">
        <h2 class="accordion-header" id="faq1">
          <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1" aria-expanded="true" aria-controls="collapse1">
            Can I change my plan later?
          </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse show" aria-labelledby="faq1" data-bs-parent="#faqAccordion">
          <div class="accordion-body">
            Yes, you can upgrade or downgrade your plan at any time. Just contact our support team to make the changes.
          </div>
        </div>
      </div>
      <div class="accordion-item">
        <h2 class="accordion-header" id="faq2">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
            What payment methods do you accept?
          </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="faq2" data-bs-parent="#faqAccordion">
          <div class="accordion-body">
            We accept all major credit cards, PayPal, and bank transfers.
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Comparison Table Section -->
<section class="py-5">
  <div class="container">
    <h2 class="text-center text-primary mb-4">Compare Plans</h2>
    <table class="table table-striped table-hover">
      <thead>
      <tr>
        <th>Feature</th>
        <th>Basic</th>
        <th>Standard</th>
        <th>Premium</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>Site Setups</td>
        <td>1</td>
        <td>3</td>
        <td>Unlimited</td>
      </tr>
      <tr>
        <td>Support</td>
        <td>24/7</td>
        <td>Priority</td>
        <td>Dedicated</td>
      </tr>
      <tr>
        <td>Cloud Storage</td>
        <td>None</td>
        <td>10 GB</td>
        <td>50 GB</td>
      </tr>
      <tr>
        <td>Bandwidth</td>
        <td>Limited</td>
        <td>Limited</td>
        <td>Unlimited</td>
      </tr>
      </tbody>
    </table>
  </div>
</section>

<!-- Testimonials Section -->
<section class="py-5 bg-light">
  <div class="container">
    <h2 class="text-center text-primary mb-4">What Our Clients Say</h2>
    <div class="row">
      <div class="col-md-6">
        <blockquote class="blockquote">
          <p>"HMC IT helped us transform our online presence. Their team is professional and reliable!"</p>
          <footer class="blockquote-footer">Jane Doe, <cite title="Company">XYZ Ltd.</cite></footer>
        </blockquote>
      </div>
      <div class="col-md-6">
        <blockquote class="blockquote">
          <p>"The Premium Plan has been a game-changer for our IT infrastructure. Highly recommend!"</p>
          <footer class="blockquote-footer">John Smith, <cite title="Company">ABC Corp.</cite></footer>
        </blockquote>
      </div>
    </div>
  </div>
</section>
